import { Component, OnInit } from '@angular/core';
import {CarService} from '../../../services/car.service';
import {ActivatedRoute, Router} from '@angular/router';
import {CarsModel} from '../../../model/car.model';

@Component({
  selector: 'app-showroom',
  templateUrl: './showroom.component.html',
  styleUrls: ['./showroom.component.css']
})
export class ShowroomComponent implements OnInit {
  cars: any;
  loading: boolean;

  pageConfig = {
    itemsPerPage: 15,
    currentPage: 1
  };

  constructor(
    private api: CarService,
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit() {
    this.pageConfig.currentPage = this.route.snapshot.params['page'];
    this.newSearchResults(this.cars);
  }

  newSearchResults(cars: CarsModel[]) {
    this.cars = cars;
  }

  pageChanged(newPage: number): void {
    this.router.navigate(['/buy-a-car',
      {
        page: newPage,
        make: this.retrieveRouteSnapshot('make') || '',
        series: this.retrieveRouteSnapshot('series') || '',
        variant: this.retrieveRouteSnapshot('variant') || '',
        year: this.retrieveRouteSnapshot('year') || '',
        selling_price: this.retrieveRouteSnapshot('selling_price') || '',
        mileage: this.retrieveRouteSnapshot('mileage') || ''
      }
    ]);
    this.pageConfig.currentPage = newPage;
    this.scrollToTop();
  }

  retrieveRouteSnapshot(urlParam: string): any {
    return this.route.snapshot.params[urlParam];
  }

  scrollToTop(): void {
    const scrollToTop = window.setInterval(() => {
      const pos = window.pageYOffset;
      if (pos > 250) {
        window.scrollTo(0, pos - 19);
      } else {
        window.clearInterval(scrollToTop);
      }
    }, 7);
  }
}
